// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { makeModulationSchemeLabel } from 'redux/helpers'
import { castToString } from 'helpers/reduxFormFunctions'

const parseModConfig = modConfigs => (
  modConfigs.reduce((a, d) => {
    const {
      attributes,
      bandwidth,
      emissionDesignator,
      enabled,
      maxAtpcTrigger,
      modelNumber,
      modulationDescription,
      modulationScheme,
      segmentEndRadioModulationId,
      throughput,
      rxThreshold,
    } = d

    // if isn't null, then use that.
    // if it is, then use rxThreshold
    const minAtpcTrigger = (
      d.minAtpcTrigger !== null
        ? d.minAtpcTrigger
        : rxThreshold
    )

    const modulationSchemeDescription = makeModulationSchemeLabel(modulationScheme)
    const modulationSchemeLabel = makeModulationSchemeLabel(modulationScheme)

    const power = castToString(d.power)
    const radioModulationId = castToString(d.radioModulationId)
    const txPowerMax = castToString(d.txPowerMax)
    const txPowerMin = castToString(d.txPowerMin)

    a.modulations.push({
      attributes,
      bandwidth,
      emissionDesignator,
      enabled,
      maxAtpcTrigger, // for ATPC trigger level
      minAtpcTrigger,
      modelNumber,
      modulationDescription,
      modulationSchemeDescription,
      modulationSchemeLabel,
      power,
      radioModulationId,
      rxThreshold,
      segmentEndRadioModulationId,
      throughput,
      txPowerMax,
      txPowerMin,
    })

    if (d.engineeringReferenceFlag) {
      a.engineeringReference = radioModulationId.toString()
    }

    if (
      enabled && (
        bandwidth > a.bandwidth ||
        a.bandwidth === undefined
      )
    ) {
      a.bandwidth = bandwidth
    }

    // since modulations are ordered by greatest throughput to least,
    // we know that the first time we find an enabled mod, it's the one with the highest throughput.
    // this modulation will allow us to define modelNumber for the radio.
    // if this modulation is changed, we will also need to change the modelNumber in the UI.
    if (enabled && !a.modelNumber) {
      a.modelNumber = modelNumber
      a.engineeringReference = radioModulationId.toString() // TODO - remove this line once API supports eng ref
    }

    // radio maxPower is based on the greatest power value of all active modulations,
    // not the 'first modulation', like above
    if (enabled && (a.maxPower === undefined || power > a.maxPower)) {
      a.maxPower = power.toString()
    }
    return a
  }, { modulations: [] })
)

export default parseModConfig
